// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"7a5c2898","453":"f19980f7"}[chunkId] + ".chunk.js";
};